import type { SVGProps } from 'react';

const SvgContracts = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="contracts">
      <path d="M28.58 30.12H7.6a1.23 1.23 0 0 1-1.24-1.23h-1.5a2.74 2.74 0 0 0 2.74 2.73h21a2.74 2.74 0 0 0 2.73-2.73V9.77a.75.75 0 0 0-.22-.53L22.34.57a.74.74 0 0 0-.52-.22H7.6a2.74 2.74 0 0 0-2.74 2.73V10h1.5V3.08A1.23 1.23 0 0 1 7.6 1.85H21L20.93 8a2.7 2.7 0 0 0 .79 1.95 2.73 2.73 0 0 0 1.94.81h6.15v5.73h-8V18h8v3.62h-5.32v1.5h5.32v5.8a1.23 1.23 0 0 1-1.23 1.2Zm-5.8-21.25a1.2 1.2 0 0 1-.35-.87V2.82L29 9.24h-5.3a1.23 1.23 0 0 1-.92-.37Z" />
      <path d="m5.87 17.37-1.06 1.07L8.33 22a.75.75 0 0 0 1.06 0l10.13-10.12-1.06-1.07-9.6 9.56Z" />
      <path d="M8.93 28.05a8.68 8.68 0 0 0 8.66-8.67 8.92 8.92 0 0 0-.21-1.93l-1.47.34a7.16 7.16 0 1 1-3-4.34l.85-1.24a8.67 8.67 0 1 0-4.83 15.84Z" />
    </g>
  </svg>
);

export default SvgContracts;
